<script>
    import { link } from "svelte-routing";
    import HeaderIntro from "../components/basic/HeaderIntro.svelte";

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let auth;
    let registerEmail = "";
    let registerPassword = "";
    let registerPasswordTwice = "";
    let registerData = {
      firstName: "",
      lastName: "",
      street: "",
      zip: "",
      city: ""
    };

    function registerNewUser() {

      if (registerPassword != registerPasswordTwice) {
        alert("Passwörter sind nicht identisch!");
        return;
      }

      for (let prop in registerData) {
        registerData[prop] = registerData[prop].trim();
        if (registerData[prop].length == 0) {
          alert("Bitte Daten angeben für: " + prop);
          return;
        }
      }

      if (!/^(\p{L}| |-){4,}((s|S)tr.)? \d{1,4}[a-zA-Z]{0,1}$/gu.test(registerData.street)) {
        alert("Fehlerhafte Straßenangabe");
        return;
      }

      if (!/^\d{5}$/gu.test(registerData.zip)) {
        alert("Fehlerhafte PLZ-Angabe");
        return;
      }


      auth.createUserWithEmailAndPassword(registerEmail, registerPassword)
        .then((userCredential) => {
          var user = userCredential.user;
          registerData.email = registerEmail;
          dispatch('registered', registerData);
        })
        .catch((error) => {
            alert("error: " + error.message);
          console.log(error);
          var errorCode = error.code;
          var errorMessage = error.message;
        });
    }

</script>


<main class="animate__fadeIn animate__animated">
    <HeaderIntro mainText={`Registrieren`} subText={"Neu auf Pausenhelden? Hier kannst du einen neuen Account anlegen und anschließend gleich deine erste Milchbestellung aufgeben."}/>
    <form class="animate__fadeInUp animate__animated" on:submit|preventDefault={registerNewUser}>
        <div class="form-group">
            <label for="registerEmail">Email-Adresse</label>
            <input type="text" class="form-control" id="registerEmail" bind:value={registerEmail}>
        </div>
        <div class="form-group">
            <label for="registerPassword">Passwort</label>
            <input type="password" class="form-control" id="registerPassword" autocomplete="new-password" bind:value={registerPassword}>
        </div>
        <div class="form-group">
          <label for="registerPasswordTwice">Passwort Wiederholen</label>
          <input type="password" class="form-control" id="registerPasswordTwice" autocomplete="new-password" bind:value={registerPasswordTwice}>
        </div>
        <hr/>
        <h5>Kontaktdaten</h5>
        <div class="form-group">
          <label for="dataName">Vorname</label>
          <input type="text" class="form-control" id="dataFirstName" bind:value={registerData.firstName}>
        </div>
        <div class="form-group">
          <label for="dataName">Nachname</label>
          <input type="text" class="form-control" id="dataLastName" bind:value={registerData.lastName}>
        </div>
        <div class="form-group">
          <label for="dataName">Straße mit Hausnummer</label>
          <input type="text" class="form-control" id="dataStreet" bind:value={registerData.street}>
        </div>
        <div class="form-group">
          <label for="dataName">Postleitzahl</label>
          <input type="text" class="form-control" id="dataZip" bind:value={registerData.zip}>
        </div>
        <div class="form-group">
          <label for="dataName">Ort</label>
          <input type="text" class="form-control" id="dataCity" bind:value={registerData.city}>
        </div>
        <button class="btn btn-specialOrange" type="submit">Registrieren</button>
        <div class="bottomNotes text-muted">
          <p>Bereits registriert?<br/><a href="/login" use:link>Hier</a> kannst du dich anmelden!</p>
        </div>
    </form>

</main>

<style>
  hr {
    background: rgba(0,0,0,0.5);
    width: calc(100% + 60px);
    transform: translateX(-30px);
    margin: 35px 0;
  }

    label {
        padding-bottom: 5px;
    }
    form {
        max-width: 400px;
        margin: 0 auto;
        text-align: left;
        background: white;
        padding: 20px 30px;
        border-radius: 10px;
        box-shadow: 0 0 8px rgb(0 0 0 / 12%);
    }
    .form-group {
        margin: 22px 0;
    }
    .form-group:first-child {
        margin-top: 0;
    }
    .bottomNotes {
        margin-top: 25px;
        font-size: 13px;
        text-align: right;
    }
</style>